const signature = '';
const expire = 0;

class UploaderService {
  constructor(props) {
    this.PATH = {
      USER_INFO: window.UPLOAD + 'xm/oss/web/token'
    };
  }

  fetchSignature() {
    let xmlhttp = null;
    if (window.XMLHttpRequest) {
      xmlhttp = new XMLHttpRequest();
    } else if (window.ActiveXObject) {
      xmlhttp = new window.ActiveXObject('Microsoft.XMLHTTP');
    }

    if (xmlhttp != null) {
      const serverUrl = window.UPLOAD + 'xm/oss/web/token';
      xmlhttp.open('GET', serverUrl, false);
      xmlhttp.send(null);
      return xmlhttp.responseText;
    }
    alert('Your browser does not support XMLHTTP.');
  }

  getVideoParseRoute(videoUrl) {
    return axios.MFS('anon/video/parse', { videoUrl }).then((res) => {
      return res.result.sdUrl || videoUrl;
    })
  }
}
export default new UploaderService();



// WEBPACK FOOTER //
// ./src/service/UploaderService.js